import unifiedPharmacyService from "../../../services/unified-pharmacy/UnifiedPharmacyService";
import i18n from "../../../i18n/index";


export default {
    data() {
        return {
            headers: [{
                text: i18n.t('headers.name'),
                sortable: false,
                value: "name"
            }, {
                text: i18n.t('headers.status'),
                sortable: false,
                value: "active"
            }],
            unifiedPharmacies: [],
            search: ''
        };
    },
    props: {},
    watch: {},
    mounted() {
        this.get();
    },
    methods: {
        onRowClick(item) {
            this.$emit("row-click", item);
        },
        get() {
            unifiedPharmacyService.get().then(response => {
                this.unifiedPharmacies = response.data;
            });
        },
        customFilter(items, search, filter) {
            search = search.toString().toLowerCase()
            return items.filter(row => filter(row["name"], search));
        }
    }
};
